import CiiCalculationInputData from "../calculation/input/data";

class CiiContributionValueData {
    constructor(dateTimeReference, name, isEditable, yearToDate, rollingTwelveMonths, unit, input) {
        this.dateTimeReference = dateTimeReference;
        this.name = name;
        this.isEditable = isEditable;
        this.yearToDate = yearToDate;
        this.rollingTwelveMonths = rollingTwelveMonths;
        this.unit = unit;
        this.input = input;
    }

    resetToDefault() {
        return new CiiContributionValueData(
            this.dateTimeReference,
            this.name,
            this.isEditable,
            this.yearToDate,
            this.rollingTwelveMonths,
            this.unit,
            this.yearToDate
        )
    }
}

class CiiContributionData {
    constructor(distance, averageLadenSpeed, averageBallastSpeed, averageLadenMeFoc, averageBallastMeFoc, excessFocDueToWeather, averageFouling, ladenPercentageTime, ballastPercentageTime, idlePercentageTime, auxCo2ContributionPercentage, cii) {
        this.distance = distance;
        this.averageLadenSpeed = averageLadenSpeed;
        this.averageBallastSpeed = averageBallastSpeed;
        this.averageLadenMeFoc = averageLadenMeFoc;
        this.averageBallastMeFoc = averageBallastMeFoc;
        this.excessFocDueToWeather = excessFocDueToWeather;
        this.averageFouling = averageFouling;
        this.ladenPercentageTime = ladenPercentageTime;
        this.ballastPercentageTime = ballastPercentageTime;
        this.idlePercentageTime = idlePercentageTime;
        this.auxCo2ContributionPercentage = auxCo2ContributionPercentage;
        this.cii = cii;
    }

    toList() {
        return [
            this.distance,
            this.averageLadenSpeed,
            this.averageBallastSpeed,
            this.averageLadenMeFoc,
            this.averageBallastMeFoc,
            this.excessFocDueToWeather,
            this.averageFouling,
            this.ladenPercentageTime,
            this.ballastPercentageTime,
            this.idlePercentageTime,
            this.auxCo2ContributionPercentage,
            this.cii
        ]
    }

    toCalculationInputData() {
        return new CiiCalculationInputData(
            this.averageLadenSpeed,
            this.averageBallastSpeed,
            this.averageLadenMeFoc,
            this.averageBallastMeFoc,
            this.excessFocDueToWeather,
            this.averageFouling,
            this.ladenPercentageTime,
            this.ballastPercentageTime,
            this.idlePercentageTime,
            this.auxCo2ContributionPercentage,
        )
    }

    resetToDefault() {
        return new CiiContributionData(
            this.distance.resetToDefault(),
            this.averageLadenSpeed.resetToDefault(),
            this.averageBallastSpeed.resetToDefault(),
            this.averageLadenMeFoc.resetToDefault(),
            this.averageBallastMeFoc.resetToDefault(),
            this.excessFocDueToWeather.resetToDefault(),
            this.averageFouling.resetToDefault(),
            this.ladenPercentageTime.resetToDefault(),
            this.ballastPercentageTime.resetToDefault(),
            this.idlePercentageTime.resetToDefault(),
            this.auxCo2ContributionPercentage.resetToDefault(),
            this.cii.resetToDefault()
        )
    }
}


export { CiiContributionValueData, CiiContributionData };
